import { render } from "./DefaultConfirmRedeem.vue?vue&type=template&id=d10df29c"
import script from "./DefaultConfirmRedeem.vue?vue&type=script&lang=js"
export * from "./DefaultConfirmRedeem.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__